import { ListCollaborator } from './ListCollaborator';
import { ListDataSource } from './ListDataSource';
import { ListView } from './ListView';
import { User } from './User';
import { Workspace } from './Workspace';

export enum ListVisibility {
    PRIVATE = 'Private',
    SHARED = 'Shared',
    WORKSPACE = 'Workspace',
}

export enum ListType {
    PEOPLE = 'People',
    COMPANIES = 'Companies',
    CUSTOM = 'Custom',
}

export interface List {
    id: string;
    workspace: Workspace;
    user: User;
    visibility: ListVisibility | undefined;
    type: ListType | undefined;
    primaryColumnKey?: string | null;
    icon: string;
    iconBackgroundColor: string;
    name: string;
    description: string;
    favorited: boolean;
    locked: boolean;
    archived: boolean;
    views: ListView[];
    dataSources: ListDataSource[];
    publiclyVisible: boolean;
    autopopulateColumns: boolean;
    collaborators: ListCollaborator[];
    createdAt: Date;
    updatedAt: Date;
    deletedAt?: Date;
}
